import React, { useState } from "react";
import Ideadox from "../../logos/Ideadox.svg";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Star from "../../logos/Star.svg";
import { caseStudies2 } from "../CaseStudy";
import CaseStudyCard from "../CaseStudyCard";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import MenuIcon from "@mui/icons-material/Menu";
import { isMobile } from "react-device-detect";

const CaseStudy9 = () => {
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const displayedCaseStudies = caseStudies2.slice(0, 3);

  return (
    <div
      style={{
        backgroundColor: "#F0DFD8",
        padding: "2rem",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        overflowX: "hidden",
        overflow: "hidden",
      }}
    >
      <header
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          padding: "1rem",
          boxSizing: "border-box",
          top: 5,
          position: "absolute",
        }}
      >
        <div
          onClick={() => navigate("/caseStudy")}
          style={{ cursor: "pointer" }}
        >
          <img src={Ideadox} alt="Ideadox" />
        </div>
        {isMobile ? (
          <div>
            <Button
              className="border border-black mt-2 rounded-full"
              onClick={handleMenuOpen}
            >
              <MenuIcon />
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              sx={{
                "& .MuiPaper-root": {
                  backgroundColor: "rgba(255, 255, 255, 0.8)", // Semi-transparent white
                  boxShadow: "none",
                },
              }}
            >
              <MenuItem
                onClick={handleMenuClose}
                style={{
                  color: "#000",
                  fontFamily: "Golos Text",
                }}
              >
                Blog
              </MenuItem>
              <MenuItem
                onClick={() => navigate("/caseStudy")}
                style={{
                  color: "#000",
                  fontFamily: "Golos Text",
                }}
              >
                Case Study
              </MenuItem>
              <MenuItem
                onClick={() => navigate("/aboutus")}
                style={{
                  color: "#000",
                  fontFamily: "Golos Text",
                }}
              >
                About
              </MenuItem>
            </Menu>
            <button className="border border-black py-1 px-2 mt-2 rounded-full hover:bg-black hover:text-white">
              Get In Touch
            </button>
          </div>
        ) : (
          <nav className="space-x-4 mr-4">
            <button
              className="hover:underline"
              onClick={() => {
                /* handle click */
              }}
            >
              Blog
            </button>
            <button
              className="hover:underline"
              onClick={() => {
                navigate("/caseStudy");
              }}
            >
              Case Study
            </button>
            <button
              className="hover:underline"
              onClick={() => navigate("/aboutus")}
            >
              About
            </button>
            <button className="border border-black py-1 px-3 rounded-full hover:bg-black hover:text-white">
              Get In Touch
            </button>
          </nav>
        )}
      </header>
      <Typography
        style={{
          fontFamily: "Bricolage Grotesque",
          fontWeight: 600,
          fontSize: isMobile ? "24px" : "48px", // Adjust font size for mobile
          color: "#2F2F30",
          lineHeight: isMobile ? "30px" : "65px", // Adjust line height for mobile
          textAlign: "left",
          marginTop: isMobile ? "80px" : "70px", // Adjust margin for mobile
          maxWidth: isMobile ? "100%" : "50%", // Adjust width for mobile
          overflowWrap: "break-word",
        }}
      >
        Improving Product Consistency and Quality with a Structured Approach
      </Typography>
      <div
        className={`flex flex-col items-start px-8 ${
          isMobile ? "mt-6" : "mt-2"
        }`}
        style={{
          marginRight: isMobile ? "50%" : "40%",
        }}
      >
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "28px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "35px",
          }}
        >
          Background
        </Typography>
      </div>
      <div>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 350,
            fontSize: isMobile ? "20px" : "20px",
            color: "#78787A",
            width: isMobile ? "110%" : "741px",
            marginTop: "10px",
            marginLeft: isMobile ? "-2%" : "",
            textAlign: "left",
          }}
        >
          Client C’s product team faced challenges with product consistency due
          to a lack of centralized ownership and unclear requirements. As a
          result, feature releases were often rushed, and bug-prone, leading to
          a suboptimal user experience and impacting customer satisfaction
        </Typography>
      </div>
      {!isMobile && (
        <div className="fixed top-28 left-20 h-1/2 w-64 p-2">
          <Typography
            style={{
              fontFamily: "Golos Text",
              fontSize: "22px",
              fontWeight: 600,
              color: "#2F2F30",
              textAlign: "left",
            }}
          >
            CONTENTS
          </Typography>
          <ul>
            <li>
              <Typography
                align="left"
                style={{
                  marginTop: "8px",
                  fontFamily: "Golos Text",
                  fontSize: "22px",
                  fontWeight: 600,
                  color: "#78787A",
                }}
              >
                Background
              </Typography>
            </li>
            <li>
              <Typography
                align="left"
                style={{
                  marginTop: "8px",
                  fontFamily: "Golos Text",
                  fontSize: "22px",
                  fontWeight: 600,
                  color: "#78787A",
                }}
              >
                CPO Approach & Solution
              </Typography>
            </li>
            <li>
              <Typography
                align="left"
                style={{
                  marginTop: "8px",
                  fontFamily: "Golos Text",
                  fontSize: "22px",
                  fontWeight: 600,
                  color: "#78787A",
                }}
              >
                Impact
              </Typography>
            </li>
          </ul>
        </div>
      )}
      <div
        className="flex flex-col items-start mt-2"
        style={{
          marginRight: isMobile ? "45%" : "9%",
          width: isMobile ? "60%" : "40%",
        }}
      >
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "22px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
            width: isMobile ? "160%" : "",
          }}
        >
          CPO Approach & Solution
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "22px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "170%" : "850px",
          }}
        >
          As the acting CPO for Client C, IDEADOX led the team in a
          comprehensive transformation to boost technical efficiency.
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "22px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
            width: isMobile ? "170%" : "90%",
          }}
        >
          Defining Product Ownership and Accountability:
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          IDEADOX introduced a dedicated product owner role to centralize and
          oversee product requirements. This role helped bridge the gap between
          business goals and technical execution, ensuring that every feature
          aligned with the overarching product vision and user expectations
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "22px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
            width: isMobile ? "170%" : "90%",
          }}
        >
          Implementing a Structured Feature Development Process
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          We established a structured product development process, including
          design reviews and quality checks at each stage. This systematic
          approach allowed for rigorous testing and review before moving to the
          development phase, minimizing bugs and refining features to better
          meet user needs.
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "22px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
            width: isMobile ? "170%" : "90%",
          }}
        >
          Improving Feature Prioritization Based on Impact and User Feedback
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          By regularly collecting and analyzing user feedback, we helped the
          client’s team prioritize features that delivered the most value to
          customers. This user-centered approach also allowed us to address
          critical pain points, improving overall satisfaction and retention.
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "28px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
          }}
        >
          Impact
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          •{" "}
          <span
            style={{
              color: "#2F2F30",
            }}
          >
            Enhanced product stability and user experience
          </span>{" "}
          with a 70% reduction in bugs reported post-release.
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          •{" "}
          <span
            style={{
              color: "#2F2F30",
            }}
          >
            Greater alignment of features with user expectations
          </span>{" "}
          resulting in improved user engagement and satisfaction.
        </Typography>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center", // Center horizontally
            marginTop: "60px",
            width: isMobile ? "160%" : "140%", // Ensure it takes full width
          }}
        >
          <img src={Star} alt="Star" style={{ marginRight: "0.5rem" }} />
          <Typography
            style={{
              fontSize: 28,
              fontFamily: "Bricolage Grotesque",
              fontWeight: 200,
              color: "#2F2F30",
            }}
          >
            Case Study
          </Typography>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center", // Center horizontally
            width: "140%", // Ensure it takes full width
          }}
        >
          <Typography
            style={{
              fontFamily: "Golos Text",
              fontSize: isMobile ? "26px" : "34px",
              fontWeight: 600,
              textAlign: "center",
              marginTop: "40px",
              marginLeft: isMobile ? "17%" : "",
            }}
          >
            Read More
          </Typography>
        </div>
        <div
          className="case-studies-list"
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "40px",
            marginTop: "20px",
            flexDirection: isMobile ? "column" : "row", // Change direction for mobile
            alignItems: isMobile ? "center" : "flex-start", // Center items on mobile
            marginLeft: isMobile ? "12%" : "",
          }}
        >
          {displayedCaseStudies.map((study, index) => (
            <div
              key={index}
              style={{
                width: "300px", // Set a consistent width
                padding: "16px",
              }}
            >
              <CaseStudyCard
                title={study.title}
                link={study.link}
                image={study.image}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CaseStudy9;
